<template>
  <v-form v-model="valid" ref="DeliveryAddressForm" @submit.prevent>
    <v-card v-if="!isNew" outlined shaped>
      <v-card-title>
        <v-icon class="mr-2">info</v-icon>Important Information
      </v-card-title>
      <v-card-text>
        Please note editing this address will not change the address on
        previously placed orders.
      </v-card-text>
    </v-card>

    <v-card flat>
      <v-card-text>
        <v-text-field
          v-model="name"
          prepend-icon="mdi-account-box-outline"
          label="Name"
          :rules="[required('Name'), maxLength(50)]"
        />

        <v-text-field
          v-model="address_line_1"
          prepend-icon="home"
          :rules="[required('Address Line 1'), maxLength(255)]"
          label="Address Line 1"
        />

        <v-text-field
          v-model="address_line_2"
          prepend-icon="mdi-empty"
          label="Address Line 2"
          :rules="[maxLength(255)]"
        />

        <v-text-field
          v-model="address_line_3"
          prepend-icon="mdi-empty"
          label="Address Line 3"
          :rules="[maxLength(255)]"
        />

        <v-text-field
          v-model="address_line_4"
          prepend-icon="mdi-empty"
          label="Address Line 4"
          :rules="[maxLength(255)]"
        />

        <v-text-field
          v-model="postcode"
          prepend-icon="mdi-post"
          :rules="[required('Postcode'), isPostCode, maxLength(255)]"
          label="Postcode"
        />

        <v-text-field
          v-model="telephone"
          prepend-icon="phone"
          :rules="[required('Telephone Number'), maxLength(20)]"
          label="Telephone Number"
        />

        <v-text-field
          v-model="order_email"
          prepend-icon="email"
          :rules="[required('Order Email Address'), maxLength(255)]"
          label="Order Email Address"
          persistent-hint
          hint="If no order email is provided we'll use this users email for order updates"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="isNew"
          type="submit"
          color="blue darken-2"
          class="white--text"
          @click.stop="submitForm"
          :disabled="!valid"
          :loading="loading"
        >
          Submit
        </v-btn>
        <v-btn
          v-else
          type="submit"
          color="blue darken-2"
          class="white--text"
          @click.stop="submitForm"
          :disabled="!valid"
          :loading="loading"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import checkPostCode from "@/util/validation/postcode.js";

export default {
  name: "DeliveryAddressForm",

  props: {
    isNew: Boolean,
    data: Object,
  },

  data: () => ({
    valid: false,
    loading: false,

    required(fieldName) {
      return (v) => (v && v.length > 0) || `${fieldName} Required`;
    },

    maxLength(length) {
      return (v) => {
        if (v) {
          if (v.length >= length) {
            return `Max Length ${length}`;
          } else {
            return true;
          }
        } else {
          return true;
        }
      };
    },

    isPostCode: (val) => {
      return checkPostCode(val);
    },

    name: null,
    address_line_1: null,
    address_line_2: null,
    address_line_3: null,
    address_line_4: null,
    postcode: null,
    telephone: null,
    order_email: null,
  }),

  methods: {
    ...mapActions(["createDeliveryAddress", "updateDeliveryAddress"]),

    resetForm() {
      this.name = null;
      this.address_line_1 = null;
      this.address_line_2 = null;
      this.address_line_3 = null;
      this.address_line_4 = null;
      this.postcode = null;
      this.telephone = null;
      this.order_email = null;
    },

    setData() {
      this.name = this.data.name;
      this.address_line_1 = this.data.address_line_1;
      this.address_line_2 = this.data.address_line_2;
      this.address_line_3 = this.data.address_line_3;
      this.address_line_4 = this.data.address_line_4;
      this.postcode = this.data.postcode;
      this.telephone = this.data.telephone;
      this.order_email = this.data.order_email;
    },

    getFormData() {
      return {
        name: this.name,
        address_line_1: this.address_line_1,
        address_line_2: this.address_line_2,
        address_line_3: this.address_line_3,
        address_line_4: this.address_line_4,

        postcode: this.postcode,
        telephone: this.telephone,
        order_email: this.order_email,
      };
    },

    async submitForm() {
      console.log("Submitting....");
      this.loading = true;
      let response = false;

      if (this.isNew) {
        console.log("New Address");
        response = await this.createDeliveryAddress({
          data: this.getFormData(),
        });
      } else {
        console.log("Updating Address");
        response = await this.updateDeliveryAddress({
          id: this.data.id,
          data: this.getFormData(),
        });
      }

      this.loading = false;

      if (response != false) {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>